/**
 * Scopo: apre e chiude i pannelli del mega menu desktop «Tessere» e filtra i marchi per iniziale.
 * Usato da: sections/custom-mega-menu.liquid (script defer, caricato su ogni pagina).
 * Dipende da: markup di snippets/nh-mega-desktop.liquid (classi nh-mm-*, data-nh-mm-*).
 *
 * Il pannello si apre al passaggio del mouse (con un breve ritardo, per non aprirlo
 * attraversando la barra) e al clic; un pannello aperto col clic resta aperto finche'
 * non si clicca fuori, si ripreme la voce o si preme Esc. Nessuna animazione serve al
 * funzionamento: con «riduci movimento» attivo il pannello compare e sparisce secco.
 */
(function () {
  'use strict';

  var nav = document.querySelector('.nh-mm');
  if (!nav || nav.getAttribute('data-nh-mm-pronto')) return;
  nav.setAttribute('data-nh-mm-pronto', '1');

  var RITARDO_APERTURA = 160;   /* ms di sosta sulla voce prima di aprire */
  var RITARDO_CHIUSURA = 280;   /* ms di tolleranza quando il mouse esce dal pannello */
  var MARGINE_FONDO = 16;       /* px liberi tra il fondo del pannello e lo schermo */
  var CLASSE_APERTA = 'nh-mm-open';

  var voci = Array.prototype.slice.call(nav.querySelectorAll('.nh-mm-item'))
    .filter(function (v) { return v.querySelector('[data-nh-mm-apri]'); });
  var timer = null;

  var pulsante = function (voce) { return voce.querySelector('[data-nh-mm-apri]'); };
  var aperta = function () {
    for (var k = 0; k < voci.length; k++) if (voci[k].classList.contains(CLASSE_APERTA)) return voci[k];
    return null;
  };
  var annullaTimer = function () { if (timer) { clearTimeout(timer); timer = null; } };

  /* Il pannello non deve uscire dallo schermo: scorre in verticale al suo interno. */
  var adattaAltezza = function (voce) {
    var pannello = voce.querySelector('.nh-mm-panel');
    var fondoBarra = nav.getBoundingClientRect().bottom;
    pannello.style.maxHeight = Math.max(200, window.innerHeight - fondoBarra - MARGINE_FONDO) + 'px';
  };

  var chiudi = function (voce) {
    voce.classList.remove(CLASSE_APERTA, 'active');
    voce.removeAttribute('data-nh-mm-fisso');
    pulsante(voce).setAttribute('aria-expanded', 'false');
  };

  var apri = function (voce, fisso) {
    voci.forEach(function (v) { if (v !== voce) chiudi(v); });
    adattaAltezza(voce);
    /* «active» accende la sottolineatura oro della voce gia' prevista da theme.css */
    voce.classList.add(CLASSE_APERTA, 'active');
    if (fisso) voce.setAttribute('data-nh-mm-fisso', '1');
    pulsante(voce).setAttribute('aria-expanded', 'true');
  };

  voci.forEach(function (voce) {
    pulsante(voce).addEventListener('click', function (ev) {
      ev.preventDefault();
      annullaTimer();
      var giaAperta = voce.classList.contains(CLASSE_APERTA);
      if (giaAperta && voce.hasAttribute('data-nh-mm-fisso')) chiudi(voce);
      else apri(voce, true);
    });

    voce.addEventListener('mouseenter', function () {
      annullaTimer();
      if (voce.classList.contains(CLASSE_APERTA)) return;
      /* Se un altro pannello e' gia' aperto si passa subito a questo. */
      if (aperta()) { apri(voce, false); return; }
      timer = setTimeout(function () { apri(voce, false); }, RITARDO_APERTURA);
    });

    voce.addEventListener('mouseleave', function () {
      annullaTimer();
      if (!voce.classList.contains(CLASSE_APERTA) || voce.hasAttribute('data-nh-mm-fisso')) return;
      timer = setTimeout(function () { chiudi(voce); }, RITARDO_CHIUSURA);
    });

    /* Tastiera: quando il fuoco esce dalla voce e dal suo pannello, il pannello si chiude. */
    voce.addEventListener('focusout', function (ev) {
      if (ev.relatedTarget && !voce.contains(ev.relatedTarget)) chiudi(voce);
    });
  });

  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('.nh-mm-item')) voci.forEach(chiudi);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    var voce = aperta();
    if (!voce) return;
    chiudi(voce);
    pulsante(voce).focus();
  });

  window.addEventListener('resize', function () {
    var voce = aperta();
    if (voce) adattaAltezza(voce);
  });

  /* Filtro dei marchi per iniziale: «Tutti» (lettera vuota) mostra tutte le tessere. */
  nav.addEventListener('click', function (ev) {
    var tasto = ev.target.closest && ev.target.closest('[data-nh-mm-lettera]');
    if (!tasto) return;
    var gruppo = tasto.closest('.nh-mm-panel');
    var lettera = tasto.getAttribute('data-nh-mm-lettera');
    gruppo.querySelectorAll('[data-nh-mm-lettera]').forEach(function (t) {
      t.setAttribute('aria-pressed', t === tasto ? 'true' : 'false');
    });
    gruppo.querySelectorAll('[data-nh-mm-iniziale]').forEach(function (cella) {
      cella.hidden = lettera !== '' && cella.getAttribute('data-nh-mm-iniziale') !== lettera;
    });
  });
})();
